var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dropdown"}},[_c('crown-color-dropdown',_vm._g({attrs:{"dropdown-open":_vm.colorDropdownOpen,"node":_vm.node,"showCustomIconPicker":_vm.showCustomIconPicker,"iconName":_vm.iconName},on:{"toggle-dropdown-state":_vm.colorDropdownToggle}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }